module.exports = __webpack_public_path__ + "static/account-details-174c5d8e7a8b65a28e8051a563a9513b.png";